/**
 * Turn a qduels spectator deep link into something openable from inside the
 * Telegram WebView.
 *
 * The link qduels emits is a raw custom scheme —
 * `clashroyale://specHostedMatch?match_tag=…&player_tag=<POV>` — the exact form
 * n8n has been firing in production. The WebView blocks custom schemes outright,
 * so we can't navigate to it directly; instead we open our own
 * `/watch-redirect.html` in the system browser (via `WebApp.openLink`), and that
 * page — which the browser *does* let launch a custom scheme — forwards to the
 * link unchanged.
 *
 * We deliberately do NOT wrap it in Supercell's `link.clashroyale.com` smart
 * link the way copyDeck does: that smart link is proven for `copyDeck` but
 * unverified for `specHostedMatch`, and wrapping would alter the byte-identical
 * link n8n already validated. The bridge page keeps the proven link intact and
 * degrades gracefully (a manual link + an "open Clash Royale" fallback) if the
 * OS doesn't hand the scheme off.
 *
 * The same page carries the iOS link of a Tennis Clash match (`tennisclash://partyMatch?…`, the
 * Limulo provider's `deepLinkIos`): Telegram's `openLink` only takes http/https, so that scheme
 * goes through here too. The page's allowlist is closed to the two schemes callers emit.
 */
export function crWatchRedirectUrl(spectatorUrl: string): string {
  const base = `${window.location.origin}/watch-redirect.html`;
  return `${base}?to=${encodeURIComponent(spectatorUrl)}`;
}
